import jsPDF from 'jspdf';
import 'jspdf-autotable';
import config from "../common/Config";
import axios from 'axios';

const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  return `${baseName}_${timestamp}.${extension}`;
};

const printNewSalesInvoice_sdm = async (orderId) => {
  const accessToken = localStorage.getItem('accessToken');
  const company_tax_type = localStorage.getItem('company_tax_type');
  const currencySymbol = localStorage.getItem('currencySymbol');

  const formData = new FormData();
  formData.set('orderId', orderId);
  const apiUrl = `${config.API_URL}/ws-new-sales-details`;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}-${month}-${year}`;
  };

  try {
    const response = await axios.post(apiUrl, formData, {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    });

    const data = response.data;
    console.log(data);

    if (!data.success || !data.details.orderDetails || data.details.orderDetails.length === 0) {
      console.error("No order details found in the response.");
      return;
    }

    const orderDetails = data.details.orderDetails[0];
    const shopDetails = data.details.shop_details;
    console.log(orderDetails);

    const totalstd = data.details.product_details
      .filter(item => item.item_tax != '0.00')
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalzeroGoods = data.details.product_details
      .filter(item => item.item_tax == '0.00')
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalSTDGoods = parseFloat(totalstd) - parseFloat(totalzeroGoods);
    const orderDiscount = parseFloat(data.details.orderDetails[0].order_discount) || 0;
    const orderDiscount1 = parseFloat(data.details.orderDetails[0].order_discount1) || 0;
    const over_all_discount = parseFloat(data.details.orderDetails[0].over_all_discount) || 0;
    const over_all_amount = parseFloat(data.details.orderDetails[0].over_all_amount) || 0;

    let totalDiscountOnVat = 0;

    if (over_all_discount > 0) {
      totalDiscountOnVat += over_all_discount;
    }

    if (data.details.orderDetails[0].percentage !== null) {
      totalDiscountOnVat += parseFloat(data.details.orderDetails[0].percentage);
    }

    let totalVAT = data.details.product_details
      .reduce((sum, item) => sum + (item.item_tax ? parseFloat(item.item_tax) : 0), 0);

    totalVAT = totalVAT - (totalVAT * totalDiscountOnVat) / 100;

    const totalAmount = totalstd + totalzeroGoods + totalVAT - over_all_amount - orderDiscount1;
    const itemTotal = totalstd + totalzeroGoods;

    const doc = new jsPDF('portrait');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    let y = margin;

    // === FIXED HEADER LAYOUT ===

    // 1. Add Logo
    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    const logoWidth = 40;
    const logoHeight = 15;
    doc.addImage(logoUrl, 'PNG', margin, y, logoWidth, logoHeight);

    // 2. Company Details (Right side of logo)
    const companyStartX = margin + logoWidth + 10; // 10px gap after logo
    let companyY = y;

    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
    doc.text(shopDetails.shop_name, companyStartX, companyY);
    companyY += 5;

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');

    // Split address into multiple lines if too long
    const addressLines = shopDetails.address.match(/.{1,50}(\s|$)/g) || [shopDetails.address];
    addressLines.forEach(line => {
      doc.text(line.trim(), companyStartX, companyY);
      companyY += 3;
    });

    companyY += 2; // Extra space
    doc.text(`Phone No : ${shopDetails.phone} | Email : ${shopDetails.email}`, companyStartX, companyY);
    companyY += 3;
    doc.text(`Website : ${shopDetails.website}`, companyStartX, companyY);
    companyY += 3;
    doc.text(`Company No : ${shopDetails.company_reg_no} | ${company_tax_type} No : ${shopDetails.vat_no}`, companyStartX, companyY);

    // Update y to the maximum of logo bottom or company details bottom
    y = Math.max(y + logoHeight, companyY) + 10; // 10px gap after header

    // 3. Customer Details and Invoice Info (Two columns)
    const customerStartY = y;
    const leftColumnWidth = pageWidth * 0.6;
    const rightColumnX = margin + leftColumnWidth + 10;

    // Left Column - Customer Details
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(orderDetails.company, margin, y);
    y += 5;

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');

    // Customer address
    const customerAddressLines = orderDetails.address.match(/.{1,40}(\s|$)/g) || [orderDetails.address];
    customerAddressLines.forEach(line => {
      doc.text(line.trim(), margin, y);
      y += 3;
    });

    y += 2;
    doc.text(`${orderDetails.city}, ${orderDetails.postal_code}`, margin, y);
    y += 3;
    doc.text(`Phone No : ${orderDetails.phone}`, margin, y);
    y += 3;
    doc.text(`Email Id : ${orderDetails.email}`, margin, y);

    // Right Column - Invoice Details
    let invoiceY = customerStartY;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');

    doc.text(`Invoice No : ${orderDetails.reference_no}`, rightColumnX, invoiceY);
    invoiceY += 4;
    doc.text(`Order Date: ${formatDate(orderDetails.date)}`, rightColumnX, invoiceY);
    invoiceY += 4;
    doc.text(`Account No: ${orderDetails.account_no}`, rightColumnX, invoiceY);

    // Set y to the bottom of whichever column is longer
    y = Math.max(y, invoiceY) + 15; // 15px gap before table

    // === TABLE GENERATION (Rest of your code remains the same) ===

    const tableColumns = [
      { title: 'Product', dataKey: 'product', size: 6, bold: false },
      { title: 'Order Type', dataKey: 'order_type', size: 6, bold: false },
      { title: 'Qty', dataKey: 'qty', size: 6, bold: false },
      { title: 'Unit Price', dataKey: 'unit_price', size: 6, bold: false },
      { title: 'Discount', dataKey: 'discount', size: 6, bold: false },
      { title: `${company_tax_type}`, dataKey: 'vat', size: 6, bold: false },
      { title: 'Net Amount', dataKey: 'net_amount', size: 6, bold: false },
    ];

    const totalWidth = pageWidth - 2 * margin;
    const productWidth = totalWidth * 0.45;
    const orderTypeWidth = totalWidth * 0.06;
    const qtyWidth = totalWidth * 0.06;
    const unitPriceWidth = totalWidth * 0.12;
    const discountWidth = totalWidth * 0.08;
    const vatWidth = totalWidth * 0.11;
    const netAmountWidth = totalWidth * 0.12;

    const tableBody = data.details.product_details.map((item) => [
      item.product_code + ' - ' + item.product_name + ' - ' + item.size + item.promo_product + item.free_product,
      item.order_type,
      parseInt(item.quantity),
      '' + parseFloat(item.unit_price).toFixed(2),
      '' + parseFloat(item.item_discount).toFixed(2),
      '' + parseFloat(item.item_tax).toFixed(2),
      '' + parseFloat(item.subtotal).toFixed(2),
    ]);

    tableBody.push([
      { content: 'Item Total:', colSpan: 6, styles: { halign: 'right' } },
      { content: `${itemTotal.toFixed(2)}` }
    ]);

    tableBody.push([
      {
        content: `NON ${company_tax_type} Goods -  ${totalzeroGoods.toFixed(2)}  | ${company_tax_type} Goods -  ${totalstd.toFixed(2)}`,
        colSpan: 5,
        styles: { halign: 'left' }
      },
      {
        content: `Total ${company_tax_type}:`,
        styles: { halign: 'right' }
      },
      {
        content: `${totalVAT.toFixed(2)}`
      }
    ]);

    tableBody.push([
      { content: `Order Discount(${over_all_discount}%)`, colSpan: 6, styles: { halign: 'right' } },
      over_all_amount.toFixed(2)
    ]);

    tableBody.push([
      { content: `Promo Discount`, colSpan: 6, styles: { halign: 'right' } },
      orderDiscount1.toFixed(2)
    ]);

    tableBody.push([
      { content: 'Total Amount:', colSpan: 6, styles: { halign: 'right' } },
      { content: `${totalAmount.toFixed(2)}` }
    ]);

    doc.autoTable({
      startY: y,
      head: [tableColumns.map(col => col.title)],
      body: tableBody,
      theme: 'grid',
      headStyles: {
        fillColor: '#f8f9fa',
        textColor: '#404040',
        fontSize: 8,
        valign: 'middle',
      },
      bodyStyles: {
        fontSize: 8,
        valign: 'middle',
      },
      margin: { top: 0, left: margin, right: margin },
      columnStyles: {
        0: { cellWidth: productWidth },
        1: { cellWidth: orderTypeWidth, halign: 'center' },
        2: { cellWidth: qtyWidth, halign: 'center' },
        3: { cellWidth: unitPriceWidth, halign: 'right' },
        4: { cellWidth: discountWidth, halign: 'center' },
        5: { cellWidth: vatWidth, halign: 'right' },
        6: { cellWidth: netAmountWidth, halign: 'right' },
      },
    });

    y = doc.autoTable.previous.finalY + 5;

    // Footer sections (keeping your existing footer logic)
    const addPageNumbers = (doc) => {
      const pageCount = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
      }
    };

    const addFooterWithSpaceCheck = (footerText, fontSize = 8, isBold = false) => {
      const remainingSpace = pageHeight - y - margin;
      const requiredSpace = 20;

      if (remainingSpace < requiredSpace) {
        doc.addPage();
        y = margin;
      }

      doc.setFontSize(fontSize);
      doc.setFont('helvetica', isBold ? 'bold' : 'normal');
      doc.text(footerText, margin, y);
      y += 5;
    };

    // Add footer content
    addFooterWithSpaceCheck('Good Received & Checked By : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ No of Boxes Received : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _');
    y += 5;
    addFooterWithSpaceCheck('Amount Paid : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ Cash / Cheque Collected By : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _');
    y += 5;
    addFooterWithSpaceCheck('Bank Details', 9, false);
    addFooterWithSpaceCheck(`A/C No : ${shopDetails.bank_ac}  |  Sort Code : ${shopDetails.sort_code}`, 9);
    y += 5;
    addFooterWithSpaceCheck('Terms -');
    addFooterWithSpaceCheck(`1 - Once delivery is received ${shopDetails.shop_name} is not responsible for any damage or loss`);
    addFooterWithSpaceCheck(`2 - Goods remain the property of ${shopDetails.shop_name} until invoice fully paid`);
    addFooterWithSpaceCheck(`3 - No claims for damages or short delivery will be considered unless made at the time of delivery of goods.`);
    addFooterWithSpaceCheck(`4 - There is No Refund Policy Of goods sold`);

    y += 10;
    addFooterWithSpaceCheck(`Note: ${orderDetails.staff_note}`, 8, true);

    addPageNumbers(doc);
    const filename = generateUniqueFilename('Invoice', 'pdf');
    doc.save(filename);
    doc.autoPrint();
    window.open(doc.output('bloburl'));

  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export default printNewSalesInvoice_sdm;